/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "No vender ni compartir mi información personal",
      "Bumble Date",
      "Nuestras apps",
      "Conócenos",
      "Empleo",
      "Contáctanos",
      "Inversores",
      "Tienda",
      "Empresa",
      "Descargar la app",
      "Accesibilidad en Bumble",
      "Normas",
      "Gestionar cookies",
      "Ley de Esclavitud Moderna",
      "Notificación de recopilación",
      "Política de Privacidad",
      "Condiciones de uso",
      "Legal",
      "Política de privacidad de la salud del consumidor de Washington",
      "Escanea el código QR para descargar la app de Bumble",
      "Rescindir contratos aquí",
      "Cerrar menú",
      "Abrir menú",
      "Selección de idioma",
      "Pie de página",
      "Accesibilidad en Bumble",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Empleo",
      "Google Play es una marca de Google LLC.",
      "Normas",
      "Inversores",
      "Gestionar cookies",
      "Declaración sobre la Modern Slavery Act",
      "Notificación de recopilación",
      "Política de privacidad",
      "Guía de citas por estaciones",
      "Condiciones de uso",
      "La app",
      "Política de privacidad de Washington Consumer Health",
      "Sobre",
      "Embajadores",
      "Haz nuevas amistades y encuentra tu comunidad",
      "Crea contactos profesionales y avanza en tu carrera",
      "Encuentra una relación, algo casual, o lo que sea entre medias",
      "Blog",
      "Descubrir más",
      "Globalízate con la función Viajes",
      "Date",
      "Funciones",
      "Compliments",
      "Utiliza Compliments para que sepa por qué te gusta.",
      "Descubre",
      "Una página personalizada que destaca a las personas más compatibles para ti, actualizada a diario.",
      "Incógnito",
      "Utiliza el modo Incógnito para ocultar tu perfil a tu jefa, familiares o a tu ex.",
      "Match al instante",
      "¿Empezasteis a hablar en un evento IRL de Bumble? ¡Que siga en la app!",
      "Opening Moves",
      "Elige Opening Moves para invitar a tu match a iniciar el chat, así no tendrás que hacerlo tú.",
      "No molestar",
      "Tómate un descanso con No molestar. Cuando te apetezca volver a las citas, ya sabes dónde estamos.",
      "SuperSwipe",
      "¿Su perfil te ha... cautivado? Házselo saber con un SuperSwipe.",
      "Viajes",
      "Encuentra tu capricho duty-free y haz match en cualquier parte del mundo con la función Viajes.",
      "Videollamada",
      "Utiliza videollamadas y llamadas de audio para ver si os apetece conoceros en persona.",
      "Aplicación web",
      "Consigue la experiencia de Bumble directamente desde tu navegador.",
      "Descarga la app Bumble",
      "BFF",
      "Seguridad",
      "Historias",
      "Ayuda",
      "Tienda",
      "Principal",
      "Lanza algunos Compliments para destacar.",
      "Compliments",
      "Funciones diseñadas para crear un espacio de relaciones reales, respetuosas y significativas.",
      "Oculta tu perfil a tu jefa, familiares o a tus ex.",
      "Incógnito",
      "Pon las citas en pausa con No molestar.",
      "No molestar",
      "¿Has visto a alguien que te gusta? Haz que lo sepa.",
      "SuperSwipe",
      "Explorar Date",
      "Encuentra tu capricho duty-free y haz match allí donde vayas.",
      "Viajes",
      "Acércate al máximo a la vida real sin salir de casa.",
      "Videollamadas",
      "Líderes que nos ayudan a llevar los valores de Bumble a sus comunidades en todo el país.",
      "Líderes de la comunidad",
      "Funciones diseñadas para ayudarte a encontrar a tu gente y conectar por lo que os apasiona.",
      "Organiza una reunión de grupo o descubre los eventos locales que se celebran en tu zona.",
      "Plans",
      "Explorar BFF",
      "Toda la orientación e inspiración que necesitas para ayudarte a encontrar el amor y la amistad.",
      "Consejos e historias para ayudarte a construir las amistades que deseas.",
      "El Centro de la Amistad",
      "Desde Tokio hasta Toronto, descubre el amor que se encuentra en Bumble por todo el mundo.",
      "Historias de amor",
      "Planifica la cita perfecta, sin importar cuándo, dónde o con quién quieras quedar.",
      "Guía de citas por estaciones",
      "Explorar historias",
      "Leer más",
      "Bumble en {{social_network}}",
      "Contáctanos",
      "Entrar",
      "(se abre en otra ventana)",
      "Preguntas",
      "Política de cookies",
      "Bumble - El Blog",
      "Empleo",
      "Chat",
      "Ciudades",
      "Gestionar cookies",
      "Copyright © 2006 - presente. Bumble. Todos los derechos reservados.",
      "Informe sobre la confianza en las citas",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc.{{__EOL__}}Google Play es una marca de Google LLC.",
      "Descargar",
      "Facebook",
      "Síguenos",
      "Centro de ayuda",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Bumble forma parte de Bumble Inc.",
      "Política de Privacidad",
      "Safety Centre",
      "Mapa web",
      "Declaración de Modern Slavery Act",
      "Condiciones de uso",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
